import { FC, useEffect, useState } from "react";
import { WithdrawalRequest } from "../../types/withdrawal-request.entity";
import { useProcessWithdrawalRequestMutation } from "../../withdrawal-requests.service";
import ActionModal from "src/components/modal/action-modal";

interface ProcessWithdrawalRequestProps {
  withdrawalRequest: WithdrawalRequest;
  action: "APPROVE" | "REJECT";
  confirmLabel: string;
  title: string;
  buttonVariant: "primary" | "danger";
}

const ProcessWithdrawalRequest: FC<ProcessWithdrawalRequestProps> = ({
  withdrawalRequest,
  action,
  confirmLabel,
  title,
  buttonVariant,
}) => {
  const [_, setIsOpen] = useState(false);
  const [processRequest, result] = useProcessWithdrawalRequestMutation();

  useEffect(() => {
    if (result.isSuccess) {
      setIsOpen(false);
    }
  }, [result]);

  const handleProcess = () => {
    processRequest({
      id: withdrawalRequest.id,
      action,
    });
  };

  const confirmButtonClasses =
    buttonVariant === "danger" ? "bg-red-600 hover:bg-red-700 text-white" : "bg-blue-600 hover:bg-blue-700 text-white";

  return (
    <ActionModal
      buttonText={confirmLabel}
      buttonClassName={
        buttonVariant === "danger"
          ? "bg-red-500 hover:bg-red-600 text-white font-semibold px-4 py-2 rounded"
          : "bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
      }
      disableCloseButton={true}
    >
      <div className="px-6 pt-4 text-center">
        <h2 className="text-lg font-semibold">{title}</h2>
        <p className="text-xl font-bold my-4 text-gray-800">&euro;{withdrawalRequest.amount}</p>
      </div>

      <div className="flex justify-end gap-2 border-t px-6 py-4 mt-2">
        <button
          onClick={() => setIsOpen(false)}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors cursor-pointer"
        >
          Close
        </button>
        <button
          onClick={handleProcess}
          disabled={result.isLoading}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer ${confirmButtonClasses} ${
            result.isLoading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {confirmLabel}
        </button>
      </div>
    </ActionModal>
  );
};

export default ProcessWithdrawalRequest;
